export default __webpack_public_path__ + "static/media/ab-dropdown.3f8cb63f.webp";